import type { AoePropagation } from '../../../ft3d/engine/ft3d-aoe-propagation.js';
export interface AoePropagationWire { casterId:string; abilityId:string; targetSelection:string; mask:AoePropagation }
declare global {
  interface Window { ftTakeAoePropagation?: (caster:string,ability:string,selection:string)=>AoePropagationWire[] }
}
/** Bound to the confirmed action. A later AOE start replaces this closure; a submit consumes it once. */
export function armAoePropagation(wire:AoePropagationWire):void {
  const expires=Date.now()+30000;
  window.ftTakeAoePropagation=(caster,ability,selection)=>{
    delete window.ftTakeAoePropagation;
    return Date.now()<=expires&&caster.toUpperCase()===wire.casterId.toUpperCase()
      &&ability.toUpperCase()===wire.abilityId.toUpperCase()&&selection===wire.targetSelection?[wire]:[];
  };
}
